import React from 'react'

function Unauthorized() {
  return (
    <div className="SuperAgent">
      <h1>Not Authorized</h1>
      <p>Additional account permissions needed to view this page.</p>
    </div>
  );
}

export default Unauthorized